import { Directive, HostListener, Input } from '@angular/core';
import { MatFileInputComponent } from 'src/lib/modules/mat-file-input/mat-file-input.component';

@Directive({
  selector: '[matFileInputTriggerFor]'
})
export class MatFileInputTriggerForDirective {

	@Input() matFileInputTriggerFor: MatFileInputComponent;

	@HostListener('dragover', ['$event']) allowDrop(event) { this.matFileInputTriggerFor.allowDrop(event); }
	@HostListener('drop', ['$event']) onDrop(event) { this.matFileInputTriggerFor.onDrop(event); }
	@HostListener('dragleave') onDragLeave () { this.matFileInputTriggerFor.onDragLeave(); }

  	constructor() { }
}
